import React from "react";
import { Controller } from "react-hook-form";
import Form from "../../Form";
import { SelectInput, SquarePlusIcon } from "djinn-components";
import FormFieldErrors from "../../Form/FormFieldErrors";
import PlanSelectField from "../CreateSiteForm/PlanSelectField";

const ChoosePlanForm = ({ siteId }: { siteId: string }) => {
  const getDefaults = () => {
    return {
      plan: null,
      period: "annual",
    };
  };

  const onSubmit = async (data: any) => {
    window.location.replace(data.url);
    // await fetchUser();
    // navigate(`/${project}`);
  };

  const periods = [
    { key: "Annually", value: "annual" },
    { key: "Monthly", value: "monthly" },
  ];

  return (
    <Form
      getDefaults={getDefaults}
      onCompleted={onSubmit}
      buttonTitle="Continue"
      endpoint={`account/subscriptions`}
      method="post"
      showReset={false}
      transformRequestData={(data) => {
        return {
          ...data,
          site_id: siteId,
        };
      }}
      render={({ errors, control, watch }) => {
        const period = watch("period");
        return (
          <>
            <div className="flex flex-col items-center justify-center max-w-sm mx-auto text-center mb-6">
              <div className="mx-auto flex items-center justify-center h-10 w-10">
                <SquarePlusIcon />
              </div>
              <h3 className="text-xl text-white">Choose A plan</h3>
              <p>
                Choose from the options below to get the most out of Appsicle,
                you can view more details on our pricing page.
              </p>
            </div>

            <div className="mb-4">
              <label
                className="mb-2 block ml-4 text-sm font-medium"
                htmlFor="period"
              >
                How would you like to pay:
              </label>

              <Controller
                name="period"
                control={control}
                defaultValue="annual"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }: any): JSX.Element => (
                  <SelectInput
                    selected={value}
                    onSelect={onChange}
                    invalid={!!errors.template}
                    label="How would you like to pay"
                    options={periods}
                  />
                )}
              />

              <FormFieldErrors
                errors={errors}
                field="period"
                requiredMessage="Your site title is required to continue"
              />
            </div>

            <div className="mb-4">
              <label
                className="mb-2 block ml-4 text-sm font-medium"
                htmlFor="plan"
              >
                Your Plan
              </label>

              <Controller
                name="plan"
                control={control}
                defaultValue=""
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }: any): JSX.Element => (
                  <PlanSelectField
                    onChange={onChange}
                    value={value}
                    period={period}
                  />
                )}
              />

              <FormFieldErrors
                errors={errors}
                field="plan"
                requiredMessage="Please choose a plan to continue"
              />
            </div>
          </>
        );
      }}
    />
  );
};

export default ChoosePlanForm;
